export const SYSTEM = {
  NOT_ENOUGH_RIGHTS: '/not-enough-rights',
  NOT_FOUND: '/404',
  ROOT: '/',
  NOT_ROLE: '/not-role',
};
